import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import block from 'bem-cn'

import { selectLocaleDict } from 'features/locale/selectors'

import { ReactComponent as NoDataIcon } from 'pages/ProfilePage/SlotsHistory/NoData/img/no-data.svg'

import './NoData.scss'

interface INoDataProps {
  isLoading?: boolean
  text?: string
}

const NoData: React.FC<INoDataProps> = ({ isLoading, text }) => {
  const b = block('profile-no-data')
  const locale = useSelector(selectLocaleDict, shallowEqual).payment

  return (
    <div className={b({ loading: isLoading })}>
      <NoDataIcon />
      <span className={b('title')}>{text || locale.noData}</span>
    </div>
  )
}

export default NoData
